import Vue from 'vue'
import App from './App.vue'
import router from './router'

// // starting Auth0 additions
// // Import the Auth0 configuration - added
// import { domain, clientId, redirectUri, audience } from '../auth_config.json'

// // Import the plugin here - added
// import { Auth0Plugin } from './auth'

// Install the authentication plugin here - added
// Vue.use(Auth0Plugin, {
//   domain,
//   clientId,
//   redirectUri,
//   audience,
//   onRedirectCallback: (appState) => {
//     router.push(
//       appState && appState.targetPath
//         ? appState.targetPath
//         : window.location.pathname
//     )
//   }
// })

// everything here below is original

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
